// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3ulpi","header":"PatientQuestionnaire_header__34v00","info":"PatientQuestionnaire_info__2DWRl"};